'use client';

import * as React from 'react';
export const PromptFieldContext = /*#__PURE__*/React.createContext(undefined);
if (process.env.NODE_ENV !== "production") PromptFieldContext.displayName = "PromptFieldContext";
export function usePromptFieldContext() {
  const context = React.useContext(PromptFieldContext);
  if (context === undefined) {
    throw new Error('MUI X: Missing context. Prompt Field subcomponents must be placed within a <PromptField /> component.');
  }
  return context;
}